// JantaDarbar.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Table } from 'react-bootstrap';
import { toast } from "react-toastify";

export const JantaDarbar = () => {
  const [formData, setFormData] = useState({
    name: '',
    village: '',
    mobile: '',
    problem: '',
    date: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();

    data.append("name", formData.name);
    data.append("village", formData.village);
    data.append("mobile", formData.mobile);
    data.append("problem", formData.problem);
    data.append("date", formData.date);

    try {
      console.log("Sending FormData...");

      await fetch(
        "https://script.google.com/macros/s/AKfycbzXy61EwsF9PP-nGiClj6bgZnaN2xZPAKy_y7I2L6r-X_lokr1DI08RG1eeTYSY7bObUw/exec",
        {
          method: "POST",
          body: data,
        }
      );

      
      setTimeout(() => {
        toast.success("Data saved successfully!");
        setFormData({ name: "", village:"",mobile: "", problem: "",date:"",});
      }, 300);
    } catch (error) {
      // 👇 Same logic as your jQuery (even if error, show success)
      toast.error("Failed!");
    }
  };
  const styles = {
    pageHeader: {
      background: 'linear-gradient(135deg, var(--saffron-deep) 0%, var(--saffron-dark) 100%)',
      padding: '60px 0 40px',
      marginTop: '75px',
      color: 'var(--white-pure)',
      textAlign: 'center'
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: 700,
      color: '#1e1e1e',
      marginBottom: '1rem',
      position: 'relative',
      display: 'inline-block'
    },
    titleUnderline: {
      width: '80px',
      height: '4px',
      backgroundColor: 'var(--saffron-deep)',
      margin: '1rem 0 2rem',
      borderRadius: '2px'
    },
    card: {
      backgroundColor: 'var(--white-pure)',
      border: '1px solid var(--saffron-light)',
      borderRadius: '20px',
      padding: '2rem',
      boxShadow: '0 10px 30px -10px rgba(229, 123, 28, 0.1)',
      transition: 'all 0.3s ease',
      height: '100%'
    },
    darbarBox: {
      backgroundColor: 'var(--saffron-soft)',
      border: '3px dashed var(--saffron-deep)',
      borderRadius: '30px',
      padding: '3rem',
      textAlign: 'center'
    },
    statCard: {
      backgroundColor: 'var(--white-pure)',
      border: '2px solid var(--saffron-deep)',
      borderRadius: '15px',
      padding: '1.5rem',
      textAlign: 'center',
      height: '100%'
    },
    successStoryCard: {
      backgroundColor: 'var(--white-pure)',
      border: '1px solid var(--saffron-light)',
      borderRadius: '15px',
      padding: '1.5rem',
      marginBottom: '1rem',
      borderLeft: '5px solid var(--saffron-deep)'
    }
  };

  // Darbar Schedule
  const darbarSchedule = {
    day: "प्रतिदिन (सोमवार से रविवार)",
    time: "शाम 7:00 बजे से रात 10:00 बजे तक",
    location: "बरवर नगर पंचायत, जनपद - खीरी (उत्तर प्रदेश)",
    nextDate: "आज",
    specialDarbar: "प्रत्येक रविवार को विशेष महिला दरबार (शाम 4-7 बजे)"
  };

  // Problem Categories
  const problemCategories = [
    { icon: "fa-land", name: "भूमि विवाद", count: "150+" },
    { icon: "fa-water", name: "जल निकासी", count: "80+" },
    { icon: "fa-road", name: "सड़क निर्माण", count: "120+" },
    { icon: "fa-bolt", name: "बिजली समस्या", count: "200+" },
    { icon: "fa-school", name: "शिक्षा", count: "60+" },
    { icon: "fa-hospital", name: "स्वास्थ्य", count: "90+" }
  ];

  // Success Stories
  const successStories = [
    {
      id: 1,
      name: "रामप्रसाद गुप्ता",
      village: "ग्राम सलेमपुर",
      date: "15 जनवरी 2025",
      problem: "सड़क निर्माण की समस्या - 3 वर्षों से गाँव की सड़क टूटी हुई थी",
      solution: "जनता दरबार में सुनवाई के बाद 1 माह में सड़क निर्माण शुरू",
      outcome: "अब गाँव तक पक्की सड़क बन चुकी है",
      icon: "fa-road"
    },
    {
      id: 2,
      name: "सुनीता देवी",
      village: "बरवर नगर",
      date: "2 फरवरी 2025",
      problem: "विधवा पेंशन नहीं मिल रही थी - 8 माह से आवेदन लंबित",
      solution: "संबंधित विभाग को निर्देश, 15 दिन में पेंशन स्वीकृत",
      outcome: "अब नियमित रूप से पेंशन मिल रही है",
      icon: "fa-female"
    },
    {
      id: 3,
      name: "हरिशंकर यादव",
      village: "ग्राम भगवानपुर",
      date: "28 फरवरी 2025",
      problem: "किसान सम्मान निधि की राशि नहीं मिल रही थी",
      solution: "कृषि विभाग में समन्वय कर समस्या का समाधान",
      outcome: "बकाया राशि 6,000 रु. खाते में जमा",
      icon: "fa-tractor"
    },
    {
      id: 4,
      name: "मोहम्मद इकबाल",
      village: "मोहम्मदी कस्बा",
      date: "10 मार्च 2025",
      problem: "पेयजल समस्या - नल से पानी नहीं आ रहा था",
      solution: "जल निगम को समस्या से अवगत कराया, मरम्मत कराई",
      outcome: "अब नियमित पानी की आपूर्ति",
      icon: "fa-water"
    }
  ];

  // Upcoming Darbar Dates
  const upcomingDarbar = [
    { date: "आज", day: "सोमवार", time: "शाम 7-10 बजे", special: "सामान्य दरबार" },
    { date: "कल", day: "मंगलवार", time: "शाम 7-10 बजे", special: "सामान्य दरबार" },
    { date: "बुधवार", day: "बुधवार", time: "शाम 7-10 बजे", special: "सामान्य दरबार" },
    { date: "रविवार", day: "रविवार", time: "शाम 4-7 बजे", special: "महिला विशेष दरबार" }
  ];

  // Statistics
  const statistics = [
    { label: "कुल सुनवाई", value: "2,500+", icon: "fa-users" },
    { label: "समस्याओं का समाधान", value: "2,100+", icon: "fa-check-circle" },
    { label: "लंबित प्रकरण", value: "400+", icon: "fa-clock" },
    { label: "संतुष्ट परिवार", value: "1,800+", icon: "fa-smile" }
  ];

  return (
    <>
      {/* Page Header */}
      <section style={styles.pageHeader}>
        <Container>
          <h1 className="display-3 fw-bold" style={{ color: 'var(--white-pure)' }}>
            <i className="fas fa-users me-3"></i>
            जनता दरबार
          </h1>
          <p className="fs-4" style={{ color: 'var(--saffron-light)' }}>
            "समस्या आपकी, संघर्ष मेरा" — क्षेत्र के हर नागरिक की सीधी सुनवाई
          </p>
        </Container>
      </section>

      {/* Main Darbar Info */}
      <section className="py-5">
        <Container>
          <div style={styles.darbarBox}>
            <i className="fas fa-gavel fa-4x mb-3" style={{ color: 'var(--saffron-deep)' }}></i>
            <h2 className="display-5 mb-3" style={{ color: 'var(--saffron-dark)' }}>जनता दरबार का उद्देश्य</h2>
            <p className="fs-5 mb-4" style={{ maxWidth: '800px', margin: '0 auto' }}>
              क्षेत्र की जनता की समस्याओं को सुनना, उनका त्वरित समाधान करना और
              प्रशासन तक जनता की आवाज़ पहुँचाना ही जनता दरबार का मुख्य उद्देश्य है।
              यहाँ हर व्यक्ति बिना किसी भय या झिझक के अपनी समस्या रख सकता है।
            </p>
          </div>
        </Container>
      </section>

      {/* Schedule and Location */}
      <section className="py-5" style={{ backgroundColor: 'var(--white-off)' }}>
        <Container>
          <h2 className="section-title text-center" style={styles.sectionTitle}>
            <i className="fas fa-clock me-2" style={{ color: 'var(--saffron-deep)' }}></i>
            दरबार का समय एवं स्थान
          </h2>
          <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

          <Row className="g-4">
            <Col lg={4}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="p-4 text-center">
                  <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                    style={{ width: '80px', height: '80px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                    <i className="fas fa-calendar-alt fa-2x" style={{ color: 'var(--saffron-deep)' }}></i>
                  </div>
                  <h4 style={{ color: 'var(--saffron-dark)' }}>दिन</h4>
                  <p className="fs-5 mb-0">{darbarSchedule.day}</p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="p-4 text-center">
                  <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                    style={{ width: '80px', height: '80px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                    <i className="fas fa-clock fa-2x" style={{ color: 'var(--saffron-deep)' }}></i>
                  </div>
                  <h4 style={{ color: 'var(--saffron-dark)' }}>समय</h4>
                  <p className="fs-5 mb-0">{darbarSchedule.time}</p>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={4}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="p-4 text-center">
                  <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                    style={{ width: '80px', height: '80px', backgroundColor: 'var(--saffron-soft)', border: '3px solid var(--saffron-deep)' }}>
                    <i className="fas fa-map-marker-alt fa-2x" style={{ color: 'var(--saffron-deep)' }}></i>
                  </div>
                  <h4 style={{ color: 'var(--saffron-dark)' }}>स्थान</h4>
                  <p className="fs-5 mb-0">{darbarSchedule.location}</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Card className="border-0 shadow-sm mt-4" style={{ backgroundColor: 'var(--saffron-soft)' }}>
            <Card.Body className="p-4">
              <div className="d-flex align-items-center justify-content-center gap-3">
                <i className="fas fa-star fa-2x" style={{ color: 'var(--saffron-deep)' }}></i>
                <p className="fs-5 mb-0">
                  <strong>विशेष:</strong> {darbarSchedule.specialDarbar}
                </p>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </section>

      {/* Statistics */}
      <section className="py-5">
        <Container>
          <h2 className="section-title text-center" style={styles.sectionTitle}>
            <i className="fas fa-chart-bar me-2" style={{ color: 'var(--saffron-deep)' }}></i>
            आंकड़े (जनता दरबार)
          </h2>
          <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

          <Row className="g-4">
            {statistics.map((stat, index) => (
              <Col md={3} key={index}>
                <div style={styles.statCard}>
                  <i className={`fas ${stat.icon} fa-3x mb-3`} style={{ color: 'var(--saffron-deep)' }}></i>
                  <h3 style={{ color: 'var(--saffron-dark)', fontSize: '2.5rem' }}>{stat.value}</h3>
                  <p className="fs-5 mb-0">{stat.label}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Problem Categories */}
      <section className="py-5" style={{ backgroundColor: 'var(--white-off)' }}>
        <Container>
          <h2 className="section-title text-center" style={styles.sectionTitle}>
            <i className="fas fa-tags me-2" style={{ color: 'var(--saffron-deep)' }}></i>
            प्रमुख समस्या श्रेणियाँ
          </h2>
          <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

          <Row className="g-4">
            {problemCategories.map((category, index) => (
              <Col md={4} lg={2} key={index}>
                <Card className="border-0 shadow-sm h-100 text-center">
                  <Card.Body className="p-3">
                    <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-2"
                      style={{ width: '60px', height: '60px', backgroundColor: 'var(--saffron-soft)', border: '2px solid var(--saffron-deep)' }}>
                      <i className={`fas ${category.icon} fa-2x`} style={{ color: 'var(--saffron-deep)' }}></i>
                    </div>
                    <h5 style={{ color: 'var(--saffron-dark)' }}>{category.name}</h5>
                    <p className="fw-bold mb-0" style={{ color: 'var(--saffron-deep)' }}>{category.count}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Success Stories */}
      <section className="py-5">
        <Container>
          <h2 className="section-title text-center" style={styles.sectionTitle}>
            <i className="fas fa-check-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
            सफलता की कहानियाँ
          </h2>
          <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

          <Row className="g-4">
            {successStories.map((story) => (
              <Col lg={6} key={story.id}>
                <div style={styles.successStoryCard}>
                  <Row>
                    <Col xs={2}>
                      <div className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: '50px', height: '50px', backgroundColor: 'var(--saffron-soft)', border: '2px solid var(--saffron-deep)' }}>
                        <i className={`fas ${story.icon}`} style={{ color: 'var(--saffron-deep)' }}></i>
                      </div>
                    </Col>
                    <Col xs={10}>
                      <div className="d-flex justify-content-between mb-2">
                        <h5 style={{ color: 'var(--saffron-dark)' }}>{story.name}</h5>
                        <span className="badge" style={{ backgroundColor: 'var(--saffron-soft)', color: 'var(--saffron-dark)' }}>
                          {story.date}
                        </span>
                      </div>
                      <p className="mb-1"><strong>गाँव:</strong> {story.village}</p>
                      <p className="mb-1"><strong>समस्या:</strong> {story.problem}</p>
                      <p className="mb-1"><strong>समाधान:</strong> {story.solution}</p>
                      <p className="mb-0"><strong>परिणाम:</strong> {story.outcome}</p>
                    </Col>
                  </Row>
                </div>
              </Col>
            ))}
          </Row>

          <div className="text-center mt-4">
            <Button
              className="px-4 py-2 rounded-pill fw-bold border-0"
              style={{ backgroundColor: 'var(--saffron-deep)', color: 'white' }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--saffron-deep)';
                e.target.style.border = '2px solid var(--saffron-deep)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = 'var(--saffron-deep)';
                e.target.style.color = 'white';
                e.target.style.border = 'none';
              }}
            >
              <i className="fas fa-plus-circle me-2"></i>
              और कहानियाँ देखें
            </Button>
          </div>
        </Container>
      </section>

      {/* Problem Registration Form */}
      <section className="py-5" style={{ backgroundColor: 'var(--saffron-soft)' }}>
        <Container>
          <Row className="g-4">
            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="p-4">
                  <h3 className="mb-4" style={{ color: 'var(--saffron-dark)' }}>
                    <i className="fas fa-pen-alt me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                    अपनी समस्या दर्ज करें
                  </h3>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>
                        <i className="fas fa-user me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        आपका नाम
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="अपना पूरा नाम लिखें"
                        required
                        style={{ borderRadius: '10px', borderColor: 'var(--saffron-light)' }}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        <i className="fas fa-home me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        गाँव / मोहल्ला
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="village"
                        value={formData.village}
                        onChange={handleChange}
                        placeholder="अपने गाँव का नाम लिखें"
                        required
                        style={{ borderRadius: '10px', borderColor: 'var(--saffron-light)' }}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        <i className="fas fa-phone me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        मोबाइल नंबर
                      </Form.Label>
                      <Form.Control
                        type="tel"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        placeholder="अपना मोबाइल नंबर दर्ज करें"
                        required
                        pattern="[0-9]{10}"
                        maxLength={10}
                        style={{ borderRadius: '10px', borderColor: 'var(--saffron-light)' }}
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>
                        <i className="fas fa-calendar me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        किस दिन आना चाहेंगे?
                      </Form.Label>
                      <Form.Select
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        required
                        style={{ borderRadius: '10px', borderColor: 'var(--saffron-light)' }}
                      >
                        <option value="">दिन चुनें</option>
                        <option value="today">आज (शाम 7-10 बजे)</option>
                        <option value="tomorrow">कल (शाम 7-10 बजे)</option>
                        <option value="sunday">रविवार (महिला दरबार, शाम 4-7 बजे)</option>
                        <option value="other">अन्य दिन</option>
                      </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label>
                        <i className="fas fa-exclamation-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                        अपनी समस्या विस्तार से लिखें
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        name="problem"
                        value={formData.problem}
                        onChange={handleChange}
                        placeholder="अपनी समस्या का विस्तार से वर्णन करें..."
                        required
                        style={{ borderRadius: '10px', borderColor: 'var(--saffron-light)' }}
                      />
                    </Form.Group>

                    <Button
                      type="submit"
                      className="w-100 py-3 fw-bold border-0"
                      style={{ backgroundColor: 'var(--saffron-deep)', color: 'white', borderRadius: '10px' }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = 'transparent';
                        e.target.style.color = 'var(--saffron-deep)';
                        e.target.style.border = '2px solid var(--saffron-deep)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = 'var(--saffron-deep)';
                        e.target.style.color = 'white';
                        e.target.style.border = 'none';
                      }}
                    >
                      <i className="fas fa-paper-plane me-2"></i>
                      समस्या दर्ज करें
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={6}>
              <Card className="border-0 shadow-sm h-100">
                <Card.Body className="p-4">
                  <h3 className="mb-4" style={{ color: 'var(--saffron-dark)' }}>
                    <i className="fas fa-info-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                    महत्वपूर्ण सूचना
                  </h3>

                  <div className="p-3 rounded-3 mb-4" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                    <h5 className="mb-3" style={{ color: 'var(--saffron-dark)' }}>
                      <i className="fas fa-clock me-2"></i>आगामी दरबार
                    </h5>
                    <Table borderless size="sm">
                      <tbody>
                        {upcomingDarbar.map((item, index) => (
                          <tr key={index}>
                            <td><i className="fas fa-calendar-check me-2" style={{ color: 'var(--saffron-deep)' }}></i>{item.date}</td>
                            <td>{item.time}</td>
                            <td><span className="badge" style={{ backgroundColor: item.special.includes('महिला') ? 'var(--saffron-deep)' : 'var(--saffron-light)', color: item.special.includes('महिला') ? 'white' : 'var(--saffron-dark)' }}>{item.special}</span></td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  <div className="p-3 rounded-3 mb-4" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                    <h5 className="mb-3" style={{ color: 'var(--saffron-dark)' }}>
                      <i className="fas fa-file-alt me-2"></i>साथ लाएँ ये दस्तावेज़
                    </h5>
                    <ul className="list-unstyled">
                      <li className="mb-2"><i className="fas fa-check-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>आधार कार्ड (अनिवार्य)</li>
                      <li className="mb-2"><i className="fas fa-check-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>समस्या से संबंधित दस्तावेज़ (यदि हों)</li>
                      <li className="mb-2"><i className="fas fa-check-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>पुरानी शिकायतों की कॉपी</li>
                      <li className="mb-2"><i className="fas fa-check-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>बैंक पासबुक (यदि पेंशन/सहायता से संबंधित हो)</li>
                    </ul>
                  </div>

                  <div className="p-3 rounded-3" style={{ backgroundColor: 'var(--saffron-soft)' }}>
                    <h5 className="mb-3" style={{ color: 'var(--saffron-dark)' }}>
                      <i className="fas fa-phone-alt me-2"></i>तुरंत संपर्क
                    </h5>
                    <p className="mb-2">
                      <i className="fas fa-mobile-alt me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      <strong>मोबाइल:</strong> 7565838125
                    </p>
                    <p className="mb-2">
                      <i className="fas fa-envelope me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      <strong>ईमेल:</strong> awashthisonamsharma@gmail.com
                    </p>
                    <p className="mb-0">
                      <i className="fas fa-clock me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                      <strong>समय:</strong> सुबह 10 बजे से रात 10 बजे तक (कॉल के लिए)
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FAQ Section */}
      <section className="py-5">
        <Container>
          <h2 className="section-title text-center" style={styles.sectionTitle}>
            <i className="fas fa-question-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
            अक्सर पूछे जाने वाले प्रश्न
          </h2>
          <div className="title-underline mx-auto mb-5" style={{ width: '80px', height: '4px', backgroundColor: 'var(--saffron-deep)' }}></div>

          <Row className="g-4">
            <Col md={6}>
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                  <h5 className="mb-2" style={{ color: 'var(--saffron-dark)' }}>
                    <i className="fas fa-question-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                    क्या जनता दरबार में आने के लिए कोई शुल्क है?
                  </h5>
                  <p>नहीं, जनता दरबार पूरी तरह से निःशुल्क है। यह जनता की सेवा के लिए है।</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                  <h5 className="mb-2" style={{ color: 'var(--saffron-dark)' }}>
                    <i className="fas fa-question-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                    क्या बिना पूर्व पंजीकरण के आ सकते हैं?
                  </h5>
                  <p>हाँ, आप बिना पंजीकरण के सीधे जनता दरबार में आ सकते हैं। टोकन प्रणाली उपलब्ध है।</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                  <h5 className="mb-2" style={{ color: 'var(--saffron-dark)' }}>
                    <i className="fas fa-question-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                    एक बार में कितने लोग आ सकते हैं?
                  </h5>
                  <p>एक समस्या के साथ अधिकतम 3 लोग आ सकते हैं। परिवार की समस्या के लिए पूरा परिवार आ सकता है।</p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="border-0 shadow-sm">
                <Card.Body className="p-4">
                  <h5 className="mb-2" style={{ color: 'var(--saffron-dark)' }}>
                    <i className="fas fa-question-circle me-2" style={{ color: 'var(--saffron-deep)' }}></i>
                    क्या समस्या का समाधान नहीं होने पर दोबारा आ सकते हैं?
                  </h5>
                  <p>हाँ, जब तक समस्या का समाधान नहीं हो जाता, आप बार-बार आ सकते हैं। हर बार आपकी सुनवाई होगी।</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Contact CTA */}
      <section className="py-5 text-center" style={{ backgroundColor: 'var(--saffron-soft)' }}>
        <Container>
          <i className="fas fa-hands-helping fa-4x mb-3" style={{ color: 'var(--saffron-deep)' }}></i>
          <h2 className="display-5 fw-bold mb-3" style={{ color: 'var(--saffron-dark)' }}>
            आपकी समस्या, हमारा संकल्प
          </h2>
          <p className="fs-4 mb-4">
            "समस्या आपकी, संघर्ष मेरा" — पंडित धीरेंद्र कुमार शर्मा
          </p>
          <Button
            href="tel:7565838125"
            className="px-5 py-3 rounded-pill fw-bold border-0"
            style={{ backgroundColor: 'var(--saffron-deep)', color: 'white', fontSize: '1.2rem' }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = 'var(--saffron-deep)';
              e.target.style.border = '2px solid var(--saffron-deep)';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'var(--saffron-deep)';
              e.target.style.color = 'white';
              e.target.style.border = 'none';
            }}
          >
            <i className="fas fa-phone-alt me-2"></i>
            अभी संपर्क करें
          </Button>
        </Container>
      </section>
    </>
  );
};

export default JantaDarbar;